/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 0:下注阶段;1:开奖中阶段;2:开奖结果展示阶段
export enum StatusEnum {
  bet = 0,
  preparing = 1,
  showRes = 2,
}

// 0: 未参与本轮;1:赢了;2:输了
export enum resStatusEnum {
  notInvolved = 0,
  win = 1,
  lose = 2,
}

// 猜礼物主页 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92454556
export const guess_gift_homepage = createAsyncThunk(
  'guess_gift_homepage',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'coin_num' // 余额
          | 'guess_gift_list' // 下注的赔率列表
          | 'guess_gift_bets' // 下注的礼物列表
          | 'round_no' // 轮次的ID
          | 'day_round' // 自然日的轮次
          | 'round_status' // 0:下注阶段;1:开奖中状态;2:开奖结果展示阶段
          | 'status_expire' // 状态剩余时间倒计时
        >
      >
    >(
      '/live/game/guess_gift_homepage',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 猜礼物开奖结果 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92456876
export const guess_gift_result = createAsyncThunk(
  'guess_gift_result',
  async (arg: {round_no: number | string}, store: any) => {
    // 每次获取开奖结果的时候将之前的结果清空
    await store.dispatch(Animal_HareSlice.actions.resetBetRes())
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'round_no' | 'win_status' | 'win_details'>>
    >(
      '/live/game/guess_gift_result',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 猜礼物下注 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92454536
export const guess_gift_bet = createAsyncThunk(
  'guess_gift_bet',
  async (arg: {bets: number[][]; room_id: number}, store: any) => {
    const resp = await http.post<HiyaRes<any>>('/live/game/guess_gift_bet', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

// 猜一猜历史 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92454669
export const guess_result_history = createAsyncThunk(
  'guess_result_history',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<any>>(
      '/live/game/guess_result_history',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

// 猜礼物下注---下注阶段下注 （支持播报）http://wiki.xunlei.cn/pages/viewpage.action?pageId=96442649
export const guess_post_bet_info = createAsyncThunk(
  'guess_post_bet_info',
  async (
    arg: {
      target_idx: number
      bet_idx: number
      bet_num: number
      room_id: number
    },
    store: any
  ) => {
    const resp = await http.post<HiyaRes<any>>(
      '/live/game/guess_post_bet_info',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 猜礼物播报 http://wiki.xunlei.cn/pages/viewpage.action?pageId=96442653
export const guess_gift_broadcasts = createAsyncThunk(
  'guess_gift_broadcasts',
  async (arg: {room_id: number}, store: any) => {
    const resp = await http.post<HiyaRes<any>>(
      '/live/game/guess_gift_broadcasts',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export interface guess_gift_list_type {
  id: number // id
  odds: number // 倍率
  icon: string // url图
  hot_topn: number // 热度
}

export interface guess_gift_bets_type {
  id: number // id
  icon: string // url图
  price: number
  single_num: number
  bet_type: number
  gift_id: number
  bag_num: number // 背包数量
}

export interface broad_casts_list_type {
  type: number // 播报类型: 1:下注广播;2:中奖广播
  nick_name: string
  icon: string
  num: number
  sum_value: number
}

export interface win_gift_list {
  gift_icon: string
  num: number
}

interface InitialStateType {
  // 开奖轮次唯一性ID
  round_no?: string
  // 当前轮次/日
  day_round?: number
  // 金币余额
  coin_num?: number
  // 下注的赔率列表 -- 六芒星礼物
  guess_gift_list?: Array<guess_gift_list_type>
  // 下注的礼物列表 -- 下注礼物
  guess_gift_bets?: Array<guess_gift_bets_type>
  // 当前轮次的状态:0:下注阶段;1:开奖中阶段;2:开奖结果展示阶段
  round_status?: number
  // 	当前状态的剩余时间: 秒数
  status_expire?: number
  // 本轮的状态:0: 未参与本轮;1:赢了;2:输了
  win_status?: resStatusEnum
  // 本轮获得list
  win_details?: Array<win_gift_list>
  hit_target_id?: number
  bag_gifts?: any
  // 结果历史
  result_his_list?: Array<guess_gift_list_type>
  // 播报信息
  broad_casts?: Array<broad_casts_list_type>
  // betloading
  betLoading?: boolean
}

const initialState: InitialStateType = {}

const initData = {
  result_his_list: [],
  betLoading: true, // 默认loading
}

export const Animal_HareSlice = createSlice({
  name: 'GuessGift',
  initialState,
  reducers: {
    initData: (state) => {
      Object.assign(state, initData)
    },
    // 清空
    resetBetRes: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        win_status: undefined,
        win_details: undefined,
      })
    },
    changeBetLoading: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        betLoading: action.payload,
      })
    },
    getWebMessage: (
      state,
      action: PayloadAction<{
        status_expire: number
        round_status: number
        hit_target_id: number
      }>
    ) => {
      Object.assign(state, action.payload)
    },
  },
  extraReducers: (builder) => {
    // 猜礼物主页
    builder.addCase(guess_gift_homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(guess_result_history.fulfilled, (state, action) => {
      Object.assign(state, {result_his_list: action.payload.list})
    })
    // 下注失败
    builder.addCase(guess_post_bet_info.fulfilled, (state, action) => {
      const {guess_gift_list} = action.payload
      if (guess_gift_list) {
        Object.assign(state, action.payload)
      }
    })
    // 播报消息
    builder.addCase(guess_gift_broadcasts.fulfilled, (state, action) => {
      Object.assign(state, {broad_casts: action.payload.list})
    })
  },
})
export default Animal_HareSlice.reducer
export const Animal_HareActions = Animal_HareSlice.actions
